import { useRef, useEffect } from 'react'
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native'
import Svg, { Path } from 'react-native-svg'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'

// ─── Re-export SectionLabel condiviso ─────────────────────────────────
export { SectionLabel } from '../ui'

// ─── rankLabel ────────────────────────────────────────────────────────
export const medal     = (pos) => pos === 1 ? '🥇' : pos === 2 ? '🥈' : pos === 3 ? '🥉' : null
export const rankLabel = (pos) => medal(pos) ?? `${pos}°`

// ─── EmptyState ───────────────────────────────────────────────────────
export function EmptyState({ icon, title, subtitle }) {
  const tc = useThemeColors()
  return (
    <View style={styles.emptyWrap}>
      <Text style={styles.emptyIcon}>{icon}</Text>
      <Text style={[styles.emptyTitle, { color: tc.text }]}>{title}</Text>
      {subtitle && <Text style={[styles.emptySubtitle, { color: tc.textMuted }]}>{subtitle}</Text>}
    </View>
  )
}

// ─── JerseyIcon ───────────────────────────────────────────────────────
export function JerseyIcon({ color, size = 16 }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <Path d="M7 2L4 5V9H7V21H17V9H20V5L17 2H15C15 3.66 13.66 5 12 5C10.34 5 9 3.66 9 2H7Z" />
    </Svg>
  )
}

// ─── PillBar ──────────────────────────────────────────────────────────
export function PillBar({ items, selectedValue, onSelect, large = false }) {
  const tc = useThemeColors()
  const scrollRef = useRef(null)

  useEffect(() => {
    if (!scrollRef.current || selectedValue == null) return
    const timer = setTimeout(() => {
      const idx = items.findIndex(i => i.value === selectedValue)
      if (idx >= 0 && scrollRef.current) {
        scrollRef.current.scrollTo({ x: idx * (large ? 120 : 90), animated: true })
      }
    }, 100)
    return () => clearTimeout(timer)
  }, [selectedValue, items, large])

  return (
    <ScrollView
      ref={scrollRef}
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={[styles.pillBarContent, { paddingVertical: large ? 10 : 6 }]}
    >
      {items.map(item => {
        const isActive = item.value === selectedValue
        return (
          <TouchableOpacity
            key={item.value}
            onPress={() => onSelect(item)}
            style={[
              styles.pill,
              {
                backgroundColor: isActive ? tc.rosa : tc.bgCard2,
                borderColor:     isActive ? tc.rosa : tc.border,
                paddingHorizontal: large ? 20 : 14,
                paddingVertical:   large ? 8  : 5,
              },
            ]}
          >
            <Text style={[
              styles.pillText,
              {
                color:      isActive ? tc.brandText : tc.textMuted,
                fontSize:   large ? 15 : 13,
                fontWeight: isActive ? '700' : '400',
              },
            ]}>
              {item.label}
            </Text>
            {item.isLive && <View style={styles.liveDot} />}
          </TouchableOpacity>
        )
      })}
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  emptyWrap:      { alignItems: 'center', justifyContent: 'center', padding: 40, paddingHorizontal: 24, gap: 12 },
  emptyIcon:      { fontSize: 44, lineHeight: 52 },
  emptyTitle:     { fontFamily: fonts.condensedBold, fontSize: 16, textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 4, textAlign: 'center' },
  emptySubtitle:  { fontSize: 13, lineHeight: 20, textAlign: 'center', maxWidth: 260 },
  pillBarContent: { paddingHorizontal: 16, gap: 8, flexDirection: 'row' },
  pill:           { borderRadius: 20, borderWidth: 1, flexShrink: 0 },
  pillText:       { fontFamily: fonts.condensedBold, letterSpacing: 0.5 },
  liveDot:        { width: 6, height: 6, borderRadius: 3, backgroundColor: '#5de09a', marginLeft: 6 },
})
